<template>
  <div class="chart">
    <canvas :ref="'backers-canvas'"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'
import chartDurationDates from '../../mixins/chart-duration-dates'
import predict from '../../mixins/predict'
import accumulate from '../../mixins/accumulate'

export default {
  name: 'bt-backers-chart',

  mixins: [chartDurationDates, predict, accumulate],

  props: {
    project: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    predictBackers() {
      return this.predict('backersAccumulator', this.durationDateList)
    },

    backersAccumulator() {
      return this.durationDateList.map((date) => {
        return this.project.backersAccumulator[date] || NaN
      })
    },

    rewindBackersAccumulation() {
      const rewindBackersAccumulation = this.accumulate(Object.values(this.project.backersAccumulator))
      let index = 0
      return this.durationDateList.map((date) => {
        if (this.project.backersAccumulator[date] !== undefined) {
          const result = rewindBackersAccumulation[index]
          index++
          return result
        } else {
          return NaN
        }
      })
    }
  },

  mounted() {
    this.backersChart = new Chart(this.$refs['backers-canvas'], {
      type: 'bar',
      data: {
        labels: this.durationDateList,
        datasets: this.getBackersChartDataset()
      },
      options: {
        maintainAspectRatio: false,
        tooltips: {
          mode: 'index',
          intersect: false
        },
        scales: {
          xAxes: [
            {
              barPercentage: 0.4,
              gridLines: {
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
              display: true,
              position: 'right',
              id: 'y-axis-1',
              ticks: {
                precision: 0,
                userCallback: (val) => {
                  return val
                    .toString()
                    .replace(
                      /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
                      (all, pre, groupOf3Digital) => pre + groupOf3Digital.replace(/\d{3}/g, ',$&')
                    )
                },
                fontColor: '#000045'
              },
              scaleLabel: {
                display: true,
                labelString: '累積集資人次',
                fontColor: '#000045',
                fontFamily: 'Noto Sans TC',
                fontSize: 13
              }
            },
            {
              type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
              display: true,
              position: 'left',
              id: 'y-axis-2',
              ticks: {
                precision: 0,
                userCallback: (val) => {
                  return val
                    .toString()
                    .replace(
                      /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
                      (all, pre, groupOf3Digital) => pre + groupOf3Digital.replace(/\d{3}/g, ',$&')
                    )
                },
                fontColor: 'rgb(241, 132, 59)'
              },
              scaleLabel: {
                display: true,
                labelString: '每日集資人次',
                fontColor: 'rgb(241, 132, 59)',
                fontFamily: 'Noto Sans TC',
                fontSize: 13
              },

              // grid line settings
              gridLines: {
                drawOnChartArea: false // only want the grid lines for one axis to show up
              }
            }
          ]
        }
      }
    })
  },

  methods: {
    getBackersChartDataset() {
      return [
        {
          label: '累積集資人次',
          type: 'line',
          data: this.backersAccumulator,
          backgroundColor: '#000045',
          fill: false,
          yAxisID: 'y-axis-1',
          borderWidth: 0
        },
        {
          label: `預計累積集資人次(${this.predictDisplay('backersAccumulator')})`,
          type: 'line',
          data: Object.values(this.predictBackers),
          backgroundColor: 'rgba(0, 0, 69, 0.3)',
          borderDash: [2, 2],
          fill: false,
          borderWidth: 0
        },
        {
          label: '每日集資人次',
          data: this.rewindBackersAccumulation,
          backgroundColor: 'rgb(241, 132, 59)',
          fill: true,
          yAxisID: 'y-axis-2',
          borderWidth: 0
        }
      ]
    }
  }
}
</script>

<style scoped>
.chart {
  height: 320px;
}
</style>
